import React from 'react';
import {Box, Chip} from '@mui/material';
import {designSystemToken, Tooltip} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

type MenuChipProps = {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  selectedOnlyMode?: boolean;
};

export default function MenuChip({
  label,
  isActive,
  onClick,
  style,
  disabled,
  selectedOnlyMode,
}: MenuChipProps) {
  return (
    <Tooltip
      title={
        disabled && selectedOnlyMode
          ? translate("Turn off 'Show selected files only' to enable")
          : ''
      }
      arrow
      type="light"
      placement="top"
    >
      <Box>
        <Chip
          label={label}
          variant={isActive && !disabled ? 'filled' : 'outlined'}
          clickable={false}
          sx={{
            borderRadius: '8px',
            borderColor: designSystemToken('semantic.bg.neutral-inverse'),
            fontSize: '14px',
            minWidth: '80px',
            ...(isActive &&
              !disabled && {
                'backgroundColor': designSystemToken('semantic.fg.neutral'),
                '&:hover': {
                  backgroundColor: designSystemToken('semantic.fg.neutral'),
                },
                'color': designSystemToken('semantic.fg.white'),
              }),
            cursor: 'pointer',
          }}
          onClick={onClick}
          style={style}
          disabled={disabled}
        />
      </Box>
    </Tooltip>
  );
}
